import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Box, Text } from '@domain-group/suit-theme'

interface QuoteBannerProps {
  displayText: string,
  icon: IconDefinition,
  iconColor: string,
}

const QuoteBanner = (props: QuoteBannerProps) => {
  const { displayText, icon, iconColor } = props

  return (
    <Box alignItems="center" flexDirection="column" justifyContent="center" paddingY="xlarge" paddingX="large">
      <Text color={iconColor} fontSize="xxlarge">
        <FontAwesomeIcon icon={icon} />
      </Text>

      <Text color="bodyFontLightColor" fontSize="small" lineHeight="1.3" marginTop="large" textAlign="center">
        {displayText}
      </Text>
    </Box>
  )
}

export default QuoteBanner
